import React, { ReactNode } from "react";
import { mergeStyles } from "@fluentui/react";
import { getSidepaneIconActionStyles, sidepaneItemHeaderStyles } from "../styles/SidepaneItem.styles";
import { Dismiss20Filled } from "@fluentui/react-icons";
import { useTheme } from "@azure/communication-react";
import { useIsMobileWithSmallHeight } from "../hooks";


export interface SidepaneItemHeaderProps {
    children: ReactNode;
    closeButtonText: string;
    close?: () => void;
}

export const SidepaneItemHeader = (props: SidepaneItemHeaderProps): JSX.Element => {
    const { children, close, closeButtonText } = props;
    const theme = useTheme();   //I guess it's v8 theme
    const isShortScreen = useIsMobileWithSmallHeight();

    return (
        <div className={mergeStyles(sidepaneItemHeaderStyles(isShortScreen))}>
            {children}

            <Dismiss20Filled className={mergeStyles(getSidepaneIconActionStyles(theme))}
                onClick={() => close ? close() : null}
                title={closeButtonText}
            />
        </div>
    );
}
